import { msg } from '@lingui/macro'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import PersonIcon from '@mui/icons-material/Person'
import ScheduleIcon from '@mui/icons-material/Schedule'
import HotelIcon from '@mui/icons-material/Hotel'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { NOTIFICATION_CATEGORIES } from './notification-center.const'

const USER_TITLES = [
  { prefix: 'Registered new user', title: msg`User registered` },
  { prefix: 'User registered', title: msg`User registered` },
  { prefix: 'User deleted', title: msg`User deleted` },
  { prefix: 'Password changed', title: msg`Password changed` },
]

const CATEGORY_META = {
  [NOTIFICATION_CATEGORIES.CRASH_ADDED]: {
    Icon: DirectionsCarIcon, color: 'error', title: msg`New crash registered`, description: msg`Crash record has been registered.`,
  },
  [NOTIFICATION_CATEGORIES.CRASH_MODIFIED]: {
    Icon: EditIcon, color: 'warning', title: msg`Crash modified`, description: msg`Crash details have been updated.`,
  },
  [NOTIFICATION_CATEGORIES.CRASH_DELETED]: {
    Icon: DeleteIcon, color: 'error', title: msg`Crash deleted`, description: msg`Crash record has been deleted.`,
  },
  [NOTIFICATION_CATEGORIES.CRASH_VALIDATED]: {
    Icon: CheckCircleIcon, color: 'success', title: msg`Crash validated`, description: msg`Crash has been validated.`,
  },
  [NOTIFICATION_CATEGORIES.OFFLINE_IMPORT]: {
    Icon: CloudUploadIcon, color: 'secondary', title: msg`Offline import`, description: null,
  },
  [NOTIFICATION_CATEGORIES.USER]: {
    Icon: PersonIcon, color: 'info', title: msg`User updated`, description: null,
  },
  [NOTIFICATION_CATEGORIES.CRASH_REQUIRES_VALIDATION]: {
    Icon: ScheduleIcon, color: 'warning', title: msg`Crash requires validation`, description: msg`Registered 30 days ago or more and requires validation.`,
  },
  [NOTIFICATION_CATEGORIES.HOSPITAL_EXIT_DATE]: {
    Icon: HotelIcon, color: 'secondary', title: msg`Exit date entered in hospital form`, description: msg`Exit date has been entered in hospital form.`,
  },
}

const FALLBACK_META = { Icon: NotificationsIcon, color: 'primary', title: msg`Notification`, description: null }

const SYSTEM_AUTHORED_CATEGORIES = new Set([
  NOTIFICATION_CATEGORIES.CRASH_REQUIRES_VALIDATION,
])

function resolveUserTitle(message = '') {
  return USER_TITLES.find(entry => message.startsWith(entry.prefix))?.title ?? CATEGORY_META[NOTIFICATION_CATEGORIES.USER].title
}

/**
 * Presentation data for a notification row. `description: null` means "show the server message".
 * @param {{ category?: string, message?: string }} notification
 */
export function getNotificationMeta(notification) {
  const { category, message } = notification ?? {}
  const meta = CATEGORY_META[category] ?? FALLBACK_META
  const title = category === NOTIFICATION_CATEGORIES.USER ? resolveUserTitle(message) : meta.title
  return { ...meta, title, isSystemAuthored: SYSTEM_AUTHORED_CATEGORIES.has(category) }
}
